/* Wellness Nest all-reviews page (FE-403 D2). Draws the Judge.me reviews that sections/wn-reviews.liquid embeds as JSON.
   Filter: product chips, star chips, with-photos. Sort: highest (default) / recent / lowest. "Show more" adds 12 cards. Review text is set with textContent only. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const grid = $('#wnr-grid'), dataEl = $('#wn-rv-data'); if (!grid || !dataEl) return;
  const R = JSON.parse(dataEl.textContent).map((r, k) => ({ ...r, k })), P = JSON.parse($('#wn-rv-products').textContent);   // k = Judge.me order (dated newest first, undated last)
  const more = $('#wnr-more'), sortEl = $('#wnr-sort'), cnt = $('#wnr-count'), none = $('#wnr-empty'), pho = $('#wnr-photos-only');
  const chips = $$('.rv-bar [data-f]'), starChips = $$('.rv-bar [data-s]'), STEP = 12; let f = 'all', st = 0, onlyPh = false, shown = 0, list = [];
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };
  const fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  const by = { recent: (a, b) => a.k - b.k, high: (a, b) => b.r - a.r || a.k - b.k, low: (a, b) => a.r - b.r || a.k - b.k };

  const stars = n => { const s = el('span', 'stars'); s.style.setProperty('--p', n * 20 + '%'); s.setAttribute('role', 'img'); s.setAttribute('aria-label', `${n} out of 5 stars`); return s; };
  const card = r => {
    const li = el('li', 'rcd'), p = P[r.p];
    if (r.ph.length) {
      const w = el('div', 'rcd__phs');
      r.ph.slice(0, 3).forEach((u, i) => {
        const a = el('a', 'rcd__ph'), im = el('img'); a.href = u + '?quality=80&width=1024'; a.target = '_blank'; a.rel = 'noopener';
        a.setAttribute('aria-label', `Open photo ${i + 1} from ${r.a}'s review (new tab)`);
        im.src = u + '?quality=80&width=240'; im.width = im.height = 96; im.loading = 'lazy'; im.alt = ''; a.append(im); w.append(a);
      });
      li.append(w);
    }
    const top = el('div', 'rcd__top'); top.append(stars(r.r));
    if (r.t) { const t = el('time', null, fmt.format(new Date(r.t))); t.dateTime = r.t.slice(0, 10); top.append(t); }   // bulk-import stamps are blanked by the sync, so a shown date is the customer's
    li.append(top);
    if (r.h) li.append(el('h3', null, r.h));
    li.append(el('p', 'rcd__body', r.b));
    const who = el('div', 'rcd__who'), av = el('span', 'rcd__av', (r.a[0] || '?').toUpperCase()); av.setAttribute('aria-hidden', 'true');
    who.append(av, el('b', null, r.a));
    if (r.v) { const vb = el('span', 'vb'); vb.innerHTML = '<svg class="icon" aria-hidden="true"><use href="#i-shield"/></svg>'; vb.append('Verified Buyer'); who.append(vb); }   // static markup only
    li.append(who);
    const pr = el('p', 'rcd__prod'), a = el('a', 'prodlink', p.t); a.href = p.u;
    if (p.i) { const im = el('img'); im.src = p.i; im.width = im.height = 32; im.loading = 'lazy'; im.alt = ''; pr.append(im); }
    pr.append(a); li.append(pr);
    return li;
  };

  const hist = $('#wnr-hist');   // counts of the whole data set, one row per star
  if (hist) for (let s = 5; s >= 1; s--) {
    const n = R.filter(r => r.r === s).length, li = el('li'), bar = el('span', 'bar'), i = el('i');
    i.style.width = (n / R.length * 100) + '%'; bar.append(i); li.append(el('span', null, `${s} ★`), bar, el('span', 'n', n)); hist.append(li);
  }

  const hit = (r, skip) => (skip === 'f' || f === 'all' || r.p === +f) && (skip === 'ph' || !onlyPh || r.ph.length) && (skip === 'st' || !st || r.r === st);
  const badge = (c, n) => { c.querySelector('small').textContent = n; c.disabled = !n && c.getAttribute('aria-pressed') !== 'true'; };   // a chip with 0 matches stays visible, greyed out; a pressed chip is never locked
  const counts = () => {   // star and photo chips count what they would show on top of the other active filters
    starChips.forEach(c => { const s = +c.dataset.s, n = R.filter(r => hit(r, 'st') && (!s || r.r === s)).length; badge(c, n); if (s) c.setAttribute('aria-label', `${s} star reviews, ${n}`); });
    badge(pho, R.filter(r => hit(r, 'ph') && r.ph.length).length);
  };
  const draw = reset => {
    if (reset) {
      list = R.filter(r => hit(r)).sort(by[sortEl.value]);
      grid.replaceChildren(); shown = 0; counts();
    }
    const next = list.slice(shown, shown + STEP); grid.append(...next.map(card)); shown += next.length;
    more.hidden = shown >= list.length; none.hidden = list.length > 0;
    cnt.textContent = list.length ? `Showing ${shown} of ${list.length} reviews` : '';
  };
  chips.forEach(c => c.addEventListener('click', () => { f = c.dataset.f; chips.forEach(x => x.setAttribute('aria-pressed', x === c)); draw(true); }));
  pho.addEventListener('click', () => { onlyPh = !onlyPh; pho.setAttribute('aria-pressed', onlyPh); draw(true); });
  sortEl.addEventListener('change', () => draw(true));
  starChips.forEach(c => c.addEventListener('click', () => { st = +c.dataset.s; starChips.forEach(x => x.setAttribute('aria-pressed', x === c)); draw(true); }));
  more.addEventListener('click', () => draw(false));
  draw(true);
})();
